import { groupBy } from "lodash";

export const groupByPostcodeLevel = (depotBoundaries) => {
  const boundariesByLevel = groupBy(depotBoundaries, "type");
  const districtBoundaries = boundariesByLevel["O"] || [];
  const sectorBoundaries = boundariesByLevel["S"] || [];

  return { districtBoundaries, sectorBoundaries };
};
